"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _sprintfJs = require("sprintf-js");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Locale = function () {
  function Locale() {
    _classCallCheck(this, Locale);

    this._resources = {};
  }

  _createClass(Locale, [{
    key: "setResources",
    value: function setResources(resources) {
      var result = {};
      var categoryNames = Object.keys(resources);
      categoryNames.forEach(function (categoryName) {
        var category = resources[categoryName];
        Object.entries(category).forEach(function (entry) {
          var _entry = _slicedToArray(entry, 2),
              resourceKey = _entry[0],
              resourceValue = _entry[1];

          result[resourceKey] = resourceValue;
        });
      });
      this._resources = result;
    }
  }, {
    key: "getResource",
    value: function getResource(key, args) {
      if (this._resources.hasOwnProperty(key)) {
        return (0, _sprintfJs.vsprintf)(this._resources[key], args);
      } else {
        return key;
      }
    }
  }]);

  return Locale;
}();

exports.default = new Locale();